import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_SAP_VERSION_3 = defineFcm('starfish_sap_version_3').asBoolean().withDefault(false).toConfig();
